/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { createEnvironmentInjector, EnvironmentInjector } from '@angular/core';
import { getAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { DomainDetectorService } from './app/services/domain-detector.service';

const injector: EnvironmentInjector = createEnvironmentInjector([DomainDetectorService], undefined as unknown as EnvironmentInjector);
const domainDetector = injector.get(DomainDetectorService);

domainDetector.detectDomain().then(domainConfig => {
    bootstrapApplication(AppComponent, getAppConfig(domainConfig.keycloakRealm))
        .catch((err) => console.error(err));
});
